module.exports = __webpack_public_path__ + "img/layers.e250712c.svg";